// extracted by mini-css-extract-plugin
export default {"tdAction":"User_tdAction__YmrPI","iconPass":"User_iconPass__M4zmr","iconEdit":"User_iconEdit__q3TqX","iconDelete":"User_iconDelete__SEa8r"};